import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  Input,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

export type CardSliderItem = {
  id: string;
  number: string;
  title: string;
  image: string;
  imageAlt: string;
  inlineSvg?: string | SafeHtml;
  text: string;
};

type SwiperContainerElement = HTMLElement & {
  initialize: () => void;
};

@Component({
  selector: 'app-card-slider',
  standalone: true,
  templateUrl: './card-slider.component.html',
  styleUrl: './card-slider.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CardSliderComponent implements AfterViewInit {
  @Input() cards: CardSliderItem[] = [];
  @ViewChild('slider', { static: true }) sliderRef?: ElementRef<SwiperContainerElement>;

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  async ngAfterViewInit(): Promise<void> {
    if (!this.isBrowser || !this.sliderRef) {
      return;
    }

    const { register } = await import('swiper/element/bundle');
    register();
    await customElements.whenDefined('swiper-container');

    Object.assign(this.sliderRef.nativeElement, {
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      navigation: true,
      loop: false,
      breakpoints: {
        700: {
          slidesPerView: 2,
          slidesPerGroup: 1
        },
        1080: {
          slidesPerView: 3,
          slidesPerGroup: 2
        }
      }
    });

    this.sliderRef.nativeElement.initialize();
  }
}
